import script from "./add-units.vue?vue&type=script&setup=true&lang=js"
export * from "./add-units.vue?vue&type=script&setup=true&lang=js"

import "./add-units.vue?vue&type=style&index=0&id=5005c83a&lang=scss&scoped=true"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5005c83a"]])

export default __exports__